import { gql } from "apollo-boost";
export const CREATE_GRID = gql`
  mutation createGrid($name: String!, $description: String!) {
    createGrid(data: { name: $name, description: $description }) {
      grid {
        name
        id
        description
      }
    }
  }
`;
export const GRID_LIST = gql`
  query getListOfGrids(
    $pageNumber: Int
    $noOfRows: Int
    $status: Int
    $name: String
    $id: Int
  ) {
    getListOfGrids(
      pageNumber: $pageNumber
      noOfRows: $noOfRows
      status: $status
      name: $name
      id: $id
    ) {
      id
      name
      description
      createdBy {
        loginId
      }
      status
    }
  }
`;

export const GRID_LIST_BY_EMPLOYEE = gql`
  query getListOfGridsByUserId(
    $pageNumber: Int
    $noOfRows: Int
    $name: String
    $id: Int
  ) {
    getListOfGridsByUserId(
      pageNumber: $pageNumber
      noOfRows: $noOfRows

      name: $name
      id: $id
    ) {
      id
      name
      description
      createdBy {
        loginId
      }
      status
    }
  }
`;

export const GRID_BY_ID = gql`
  query getGridById($id: Int) {
    getGridById(id: $id) {
      id
      name
      description
      status
      canEdit
      targetGridId
      referenceColumn
      canMove
      columnData
      createdBy {
        loginId
      }
      createdOn
      lastModifiedBy {
        loginId
      }
      lastModifiedOn
    }
  }
`;

export const UPDATE_GRID = gql`
  mutation updateGrid(
    $name: String!
    $description: String!
    $id: Int!
    $status: Int!
  ) {
    updateGrid(
      data: { name: $name, description: $description, status: $status }
      id: $id
    ) {
      message
    }
  }
`;

export const CRETA_GRID_COLUMN = gql`
  mutation addGridColumn(
    $columnName: String!
    $columnType: String!
    $width: Int!
    $alignment: String!
    $required: Boolean!
    $id: Int!
  ) {
    addGridColumn(
      data: {
        columnName: $columnName
        columnType: $columnType
        width: $width
        alignment: $alignment
        required: $required
      }
      id: $id
    ) {
      message
    }
  }
`;

export const DELETE_GRID_COLUMN = gql`
  mutation removeGridColumn($columnId: String!, $id: Int!) {
    removeGridColumn(columnId: $columnId, id: $id) {
      message
    }
  }
`;
export const UPDATE_GRID_COLUMN = gql`
  mutation updateGridColumn(
    $columnName: String!
    $columnType: String!
    $width: Int!
    $alignment: String!
    $required: Boolean!
    $id: Int!
    $ColumnId: String!
  ) {
    updateGridColumn(
      data: {
        columnName: $columnName
        columnType: $columnType
        width: $width
        alignment: $alignment
        required: $required
        id: $ColumnId
      }
      id: $id
    ) {
      message
    }
  }
`;

export const EMPLOYEE_LIST = gql`
  query(
    $offset: Int
    $pageNo: Int
    $employeeId: String
    $name: String
    $emailId: String
    $status: Int
  ) {
    getListOfOrgUsers(
      NoOfRows: $offset
      offset: $pageNo
      employeeId: $employeeId
      name: $name
      emailId: $emailId
      status: $status
    ) {
      Id
      name
      employeeId
      userId
      emailId
    }
  }
`;

export const ADD_GRID_USER = gql`
  mutation addGridUsers($userId: [Int]!, $gridId: Int!) {
    addGridUsers(data: { userId: $userId, gridId: $gridId }) {
      gridusers {
        id
      }
    }
  }
`;

export const GRID_EMPLOYEE_LIST = gql`
  query($gridId: Int) {
    getListOfUsersByGridId(gridId: $gridId) {
      id
      userId {
        loginId
        Id
      }
      userDetail {
        name
      }
    }
  }
`;
export const DELETE_GRID_USER = gql`
  mutation removeGridUsers($id: String!) {
    removeGridUsers(id: $id) {
      message
    }
  }
`;

export const GET_GRID_DATA = gql`
  query getListOfGridDataByGridId($gridId: Int) {
    getListOfGridDataByGridId(gridId: $gridId) {
      data
      id
      orderNo
      canMoveData
    }
  }
`;
export const ADD_GRID_ADD = gql`
  mutation addGridData($gridId: Int!, $rowDataNew: [GridDataInputType]!) {
    addGridData(data: $rowDataNew, gridId: $gridId) {
      gridData {
        id
      }
    }
  }
`;

export const DELETE_GRID_ROW = gql`
  mutation removeGridData($id: String!) {
    removeGridData(id: $id) {
      message
    }
  }
`;

export const UPDATE_GRID_DATA = gql`
  mutation updateGridData(
    $id: String!
    $rowDataNew: [UpdateGridDataInputType]!
  ) {
    updateGridData(data: $rowDataNew, id: $id) {
      message
    }
  }
`;

export const DELETE_ALL_GRID_DATA = gql`
  mutation removeAllGridData($gridId: Int!) {
    removeAllGridData(gridId: $gridId) {
      message
    }
  }
`;

export const DOWNLOAD_EXCEL_FILE = gql`
  query downloadGridReport($gridId: Int) {
    downloadGridReport(gridId: $gridId)
  }
`;

export const MOVE_GRID_DATA_ROW = gql`
  mutation moveGridDataToAnotherGrid($id: String!) {
    moveGridDataToAnotherGrid(id: $id) {
      message
    }
  }
`;
export const UPDATE_MOVE_GRID_DATA = gql`
  mutation updateMoveGridInfo(
    $canMove: Boolean!
    $targetGridId: Int!
    $referenceColumn: String!
    $gridId: Int!
  ) {
    updateMoveGridInfo(
      data: {
        canMove: $canMove
        targetGridId: $targetGridId
        referenceColumn: $referenceColumn
      }
      gridId: $gridId
    ) {
      message
    }
  }
`;
